<div class="orange" *ngIf="topheaderbanner">
  <div [class]="containerCss" [innerHtml]="topheaderbannerHTMl"></div>
</div>
<nav
  class="navbar navbar-expand-lg navbar-dark   mb-3 head-top {{
    navbarcss
  }} fixed-top"
>
  <div [class]="containerCss">
    <div class="row">
      <div class="col-md-3 logo-m-v col-6">
        <a class="navbar-brand">
          <img class="header-logo" [src]="imageURL" alt="" />
          <div
            class="logotxt"
            *ngIf="logowithtxt"
            [innerHtml]="logowithtxtHTML"
          ></div>
        </a>
      </div>

      <div class="col-md-4 text-center hd-nm">
        <!-- <h3 class="mt-3">Top5 Colleges</h3> -->
      </div>
      <div
        *ngIf="!isLoginByRequestUrl"
        class="col-md-5 col-6 hoursadd d-flex align-items-center justify-content-end"
      >
        <div class="timmer-rw">
          <p *ngIf="loginInfo?.showTimer == true" class="hoursaddcontain">
            <span class="red"
              ><span class="red">{{ time }}</span> left for trial</span
            >
          </p>
          <!-- *ngIf=" -->
          <p class="hoursaddcontain" *ngIf="this.hidePaysubscriberBtn == false">
            <a
              tuiButton
              type="submit"
              (click)="innerbutton()"
              target="_blank"
              class="btn btn-primary page-btn m-0"
            >
              Pay & Subscribe
            </a>
          </p>
        </div>
        <div class="d-flex align-items-center justify-content-end">
          <span *ngIf="userType != 'STUDENT'" class="dasboardlink">
            <a
              (click)="clickLink()"
              target="_blank"
              class="mb-4 items-center top5-link bg-gray-200 w-full px-2 py-2 text-blue-800 shadow rounded capitalize text-sm hover:text-teal-200 transition ease-in-out duration-500"
              ><img
                src="https://cdn.virtueanalytics.com/no-cache/top5-icon-link.png"
              />
              Dashboard</a
            >
          </span>
          <div class="lgout header">
            <div class="flex flex-row-reverse items-center">
              <ul class="d-flex align-items-center m-0 p-0">
                <li class="dropup">
                  <span
                    [ngClass]="srcProfile ? 'logo-section' : 'text-logo'"
                    class="pe-auto align-middle rounded-full focus:shadow-outline-purple focus:outline-none dropbtn"
                    aria-label="Account"
                    aria-haspopup="true"
                  >
                    <img
                      *ngIf="srcProfile"
                      [src]="srcProfile"
                      class="w-8 h-8 rounded-2xl v-icon"
                    />
                    <h3
                      *ngIf="!srcProfile"
                      class="h-8 w-8 border-2 text-gray-800 rounded-full p-1 border-gray-600"
                    >
                      {{ getFirstLetters(FullName) }}
                    </h3>
                  </span>

                  <div class="dropup-content">
                    <ul
                      x-transition:leave="transition ease-in duration-150"
                      x-transition:leave-start="opacity-100"
                      x-transition:leave-end="opacity-0"
                      class="absolute right-0 w-56 p-2 mt-2 bg-gray-100 border-gray-400 shadow space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
                      aria-label="submenu"
                    >
                      <li class="flex">
                        <a
                          class="inline-flex items-center w-full px-2 py-1 text-sm font-normal transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                        >
                          <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                          <span (click)="openProfileModelBox()">{{
                            FullName
                          }}</span>
                        </a>
                      </li>

                      <li class="flex">
                        <a
                          class="inline-flex items-center w-full px-2 py-1 text-sm font-normal transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                        >
                          <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                          <span (click)="MyAccount()"> My Account </span>
                        </a>
                      </li>

                      <li class="flex">
                        <a
                          class="inline-flex items-center w-full px-2 pt-2 border-gray-400 border-t text-sm font-normal transition-colors duration-150 hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                        >
                          <i class="fa fa-sign-out" aria-hidden="true"></i>

                          <span (click)="onLogout('Manual')" *ngIf="logoutuser"
                            >Log out</span
                          >
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="isLoginByRequestUrl"
        class="col-md-4 col-xs text-right lgout hed-btn"
      >
        <button
          class="btn btn-outline-dark btn-sm mt-2 mb-2"
          (click)="onLogout('Manual')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
            />
          </svg>
          Logout
        </button>
      </div>
    </div>
  </div>
</nav>
